/**
 * Ce composant se charge de remplacer la pagination d'une
 * page produit par un défilement infini.
 */

var spinner = '<div id="spinner"><div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div></div>';
var scrolling = 0;

jQuery(function ($) {
if ($('.woocommerce-pagination').length) {
    $('.woocommerce-pagination').hide();

    $(window).on('scroll', function () {
        scrolling = 1;
    });

    // On guette l'événement « scroll » que toutes les 500 ms
    setInterval(function () {
        if (scrolling) {
            scrolling = 0;

            var totalPageHeight = document.body.scrollHeight;
            var scrollPoint = window.scrollY + window.innerHeight;
            var offset = 750;

            if (scrollPoint >= totalPageHeight - offset) {

                // On est en bas de page, on simule un clic sur « Suivant »
                var next = $('.woocommerce-pagination a.next');
                if (next.length && $('#spinner').length == 0) {
                    $.ajax({
                        url: next.attr('href'),
                        dataType: "html",
                        beforeSend: function () {
                            $("#js-product-list").append(spinner);
                        }
                    }).done(function (html) {
                        $('#js-product-list').append($(html).find('.container--archive-products'));
                        $('.woocommerce-pagination .page-numbers').replaceWith($(html).find('.woocommerce-pagination .page-numbers'));
                        $('#spinner').remove();
                    });
                }
            }
        }
    }, 500);
    /**
         * Dans le cas où on utilise la navigation à facette, le DOM
         * change fortement. Il est alors nécessaire de masquer à nouveau
         * la pagination.
         */
    $(document).ajaxSuccess(function (event, xhr, settings) {
        if (xhr.responseJSON && xhr.responseJSON.rendered_facets != undefined) {
            $('.woocommerce-pagination').hide();
        }
    });
}
});